/*jslint strict:false */

var template_large = templater`<div class="grid-cell block-ticket">
    	<div class="ticket-image" style="background-image: url('${'featured_photo'}');"></div>

    	<div class="ticket-content">
    		<span class="date">${'event_datetime'}</span>
    		<span class="title">${'artist'}</span>

    		<div class="event-details">
    			<div class="details-row"><strong>Venue:</strong> <a href="${'venue_url'}">${'venue'}</a></div>
    			<div class="details-row"><strong>Location:</strong> <a href="/events?city=${'venue_location_formatted'}">${'venue_location'}</a></div>

    			<a href="${'ticket_url'}" target="_blank" class="button alt">Buy Tickets</a>
    		</div>
    	</div>
    </div>`,
    template_small_venue = templater`<div class="grid-cell">
    	<a href="${'event_url'}" class="block-ticket">
    		<div class="ticket-image" style="background-image: url('${'featured_photo'}');"></div>

    		<div class="ticket-content">
        <span class="date">${'event_datetime'}</span>
        <span class="title">${'artist'}</span>
    		</div>
    	</a>

    	<div class="event-details">
    		<div class="grid-cell">
    			<div class="details-row"><strong>Venue:</strong> <a href="${'venue_url'}">${'venue'}</a></div>
    			<div class="details-row"><strong>Location:</strong> <a href="/events?city=${'venue_location_formatted'}">${'venue_location'}</a></div>
    		</div>

    		<div class="grid-cell">
    			<a href="${'ticket_url'}" target="_blank" class="button mobile-alt">Buy Tickets</a>
    		</div>
    	</div>
    </div>`,
    template_small_artist = templater`<div class="grid-cell">
    	<a href="${'event_url'}" class="block-ticket">
    		<div class="ticket-image" style="background-image: url('${'featured_photo'}');"></div>

    		<div class="ticket-content">
    			<span class="date">${'event_datetime'}</span>
    			<span class="title">${'venue'}</span>
    		</div>
    	</a>

    	<div class="event-details">
    		<div class="grid-cell">
    			<div class="details-row"><strong>Artist:</strong> ${'artist'}</div>
    			<div class="details-row"><strong>Location:</strong> <a href="/events?city=${'venue_location_formatted'}">${'venue_location'}</a></div>
    		</div>

    		<div class="grid-cell">
    			<a href="${'ticket_url'}" target="_blank" class="button mobile-alt">Buy Tickets</a>
    		</div>
    	</div>
    </div>`;

function templater(strings, ...keys) {
  return function(data) {
    let temp = strings.slice();
    keys.forEach((key, i) => {
      temp[i] = temp[i] + data[key];
    });
    return temp.join('');
  };
}

function convertToDom(html) {
  'use strict';

  var d = document.createElement('div');
  d.innerHTML = html;
  return d.firstChild;
}
